<template>
  <div class="bg" style="height: 99%;overflow: hidden">
    <div class="traceData">
      <a-input placeholder="请输入产品码" v-model="searchInfo" ></a-input>
      <a-button type="primary" icon="search" @click="onChange" class="custom-button"></a-button>
    </div>
    <!-- <div v-if="loading" style="padding-top: 20vh;font-size: 30px;font-weight: 700;color: #ffffff">
      正在查询...searchInfo
    </div>
    <div v-if="timeline.length == 0 && first && !loading" style="padding-top: 20vh;font-size: 30px;font-weight: 700;color: #ffffff">
      查询结果:暂无内容
    </div> -->
    <div v-if="traceDatas" class="traceInfo">
      <a-collapse v-model="activeKey" :bordered="false" class="accordion">
        <a-collapse-panel header="产品信息" key="1" class="accordion-panel">
          <p >产品名称: {{ traceDatas.name || '--' }}</p>
          <p >规格: {{ traceDatas.standard || '--'  }}</p>
          <p >单位: {{ traceDatas.unit || '--'  }}</p>
        </a-collapse-panel>
        <a-collapse-panel header="追溯信息" key="2" class="accordion-panel">
          <div class="timeline-container">
            <a-timeline>
              <a-timeline-item v-for="(item, index) in timeline" :key="index">
                <p>时间: {{ item.operatorTime }}</p>
                <p>操作人: {{ item.operatorMes }}</p>
                <p>事件类型: {{ item.traceMes }}</p>
                <!-- <p>事件详情: {{ item.text }}</p> -->
              </a-timeline-item>
            </a-timeline>
          </div>

        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>

<script>
  import { anayliseCodeNoTemplate } from '@api/api'

  export default {
    name: "traceData",
    components: {

    },
    data() {
      return {
        searchInfo: '',
        traceDatas: {},
        loading: false,
        first: true,
        timeline: [],
        activeKey: ['1'], // 默认展开第一个面板
      }
    },
    created() {

    },
    methods: {
      onChange(){
        this.traceDatas = {}
        this.timeline = []
        this.loading = true
        anayliseCodeNoTemplate({code:this.searchInfo}).then(res=>{
          if( res.code == 200 && res.success == true ){

            this.loading = false
            if( res.result == null ){
              this.traceDatas = {}
            } else {
              this.traceDatas = res.result.materialMes
              this.timeline = res.result.traceMessages
            }

          } else {
            this.$message.error(res.message)
          }
          // }
        }).catch(err=>{
          this.loading = false
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .bg{
    background-image: url("/static/traceBg.jpg");
    background-size: 100% 100%;
  }
  .traceData {
    width: 50%;
    margin: 100px auto 0;
    display: flex;
    justify-content: flex-start;
    .ant-input {
      height: 50px;
      line-height: 50px;
    }
    .custom-button {
      width: 50px; /* 自定义宽度 */
      height: 50px; /* 自定义高度 */
      font-size: 16px; /* 自定义字体大小 */
    }
  }
  .accordion {
    width: 90%;
    margin: 40px auto 0;
  }
  .accordion-panel{
    p {
      padding: 0 20px;
    }
    .ant-collapse-content {
      margin: 0 20px;
    }
  }
  .timeline-container {
    max-height: 400px; /* 设置一个最大高度 */
    overflow-y: auto; /* 启用垂直滚动条 */
  }
</style>
